import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

interface BilledAnnuallyButtonProps {
	onClick: () => void;
}

export const BilledAnnuallyButton = (props: BilledAnnuallyButtonProps) => {
	return (
		<button
			css={[
				css({
					background: 'transparent',
					border: 0,
					cursor: 'pointer',
					color: '#0065ff',
					fontFamily: 'inherit',
					fontSize: 'inherit',
					lineHeight: 0,
					margin: '0 2px',
					padding: 0,
					textOverflow: 'ellipsis',
					textDecoration: 'underline',
					whiteSpace: 'nowrap',
					':hover': {
						// eslint-disable-next-line local/ensure-wac-token-usage
						color: '#0049b0',
					},
				}),
			]}
			type="button"
			onClick={props.onClick}
			tabIndex={0}
			data-event-component="linkButton"
			data-event="clicked"
		>
			<FormattedMessage
				id="Pricing.card.body.enterprise.billedAnnually"
				defaultMessage="Billed annually."
			/>
		</button>
	);
};
